import type { FocusEvent } from 'react'
import { useEffect, useState } from 'react'

import type { InputProps } from '@twisto/components/atoms/input/input-common'

type Args = {
  defaultValue: boolean
  onBlur: InputProps['onBlur']
  onFocus: InputProps['onFocus']
}

export const useFocus = ({ defaultValue, onBlur, onFocus }: Args) => {
  const [isFocused, setIsFocused] = useState(defaultValue)

  useEffect(() => {
    setIsFocused(defaultValue)
  }, [defaultValue])

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    setIsFocused(false)
    if (onBlur) {
      onBlur(event)
    }
  }

  const handleFocus = (event: FocusEvent<HTMLInputElement>) => {
    setIsFocused(true)
    if (onFocus) {
      onFocus(event)
    }
  }

  return {
    isFocused,
    handleBlur,
    handleFocus,
  }
}
